export default "__VITE_ASSET__buX_bUDtjhxkXwpG$r4caQ__"